// REACT & REDUX
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { Field, Form, reduxForm } from "redux-form";
import { ToastContainer, toast } from "react-toastify";
import * as http from "../../api/base.api";
import moment from "moment";
import { compose } from "redux";
import PropTypes from "prop-types";

// STYLE, PROPS & TRANSLATIONS
import { translate } from "react-i18next";

// COMMON
import { required, maxLength } from "../../common/validators";
import { CERTIFICATE_SUBMIT_FORM } from "../../actions/actionTypes";

// COMPONENTS
import { Brand, Table, CardBody, Button, FlexContainer, FlexItem, Spinner, TextInput, InputContainer } from "careconnect-ui";
import ReduxFieldText from "../common/ReduxFieldText";
import { convertDataToFormDataFormat } from "../../common/helpers.js";
import { CopyToClipboard } from "react-copy-to-clipboard";

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************

const requiredVal = required();
const max50 = maxLength(50);
const TOAST_OPTS = { position: toast.POSITION.TOP_CENTER};


class Upload extends Component {
    constructor() {
        super();
        this.state = {
            files: [],
            hcoNumber: "",
            clientid: "",
            secretid: "",
            isAuthenticated: false,
            clientSecrets: [],
            loading: true,
            selectedIndex: 0,
            savedSucceed: false,
            applicationId: ""
        };
    }
    changeLanguage = lng => this.props.i18n.changeLanguage(lng);

    onDrop = (files = []) => {
        if (!files.length || !files[0]) {
            toast.error(this.props.t("error.file.required"), TOAST_OPTS);
            return;
        }

        const file = files[0];
        const name = (file.name || "").toLowerCase();
        const type = (file.type || "").toLowerCase();

        const allowedExt = [".pfx", ".p12", ".acc-p12"];
        const allowedMime = ["application/x-pkcs12", "application/octet-stream"];

        const hasValidExt = allowedExt.some(ext => name.endsWith(ext));
        const hasValidMime = allowedMime.includes(type);

        if (!hasValidExt && !hasValidMime) {
            toast.error(this.props.t("error.format.invalid"), TOAST_OPTS);
            return;
        }

        this.setState({ files });
        this.props.dropFileCompleted(files);
    };

    async componentDidMount() {
        const usersInfo = await http.get(`api/certificates/`).then(
            r => r.data,
            () => ""
        );
        this.setState({ files: [] });

        if (usersInfo.isAuthenticated) {
            const list = Array.isArray(usersInfo.clientSecrets) ? usersInfo.clientSecrets : [];
            this.setState({
                loading: false,
                isAuthenticated: true,
                clientid: "",
                secretid: "",
                clientSecrets: list,
                applicationId: "",
                savedSucceed: false
            });
            if (list.length) this.props.clientSecretsInitialize(list);
        } else {
            this.setState({ isAuthenticated: false, clientid: undefined, secretid: undefined, loading: false });
        }
    }

    onSubmit = (values = {}) => {
        const { t } = this.props;
        const { files, savedSucceed, clientSecrets, selectedIndex } = this.state;
        const hasFiles = files && files.length > 0;

        if (!savedSucceed && !hasFiles) {
            toast.error(t("error.certificate.required"), TOAST_OPTS);
            return;
        }
        if (!values.KeyStore) {
            toast.error(t("error.keyStore.required"), TOAST_OPTS);
            return;
        }
        if (values.KeyStoreVerification !== values.KeyStore) {
            toast.error(t("error.keyStore.different"), TOAST_OPTS);
            return;
        }
        if (!values.Riziv) {
            toast.error(t("error.riziv.required"), TOAST_OPTS);
            return;
        }

        const idx = selectedIndex - 1;
        if (idx < 0 || !clientSecrets[idx]) {
            toast.error(t("error.riziv.required"), TOAST_OPTS);
            return;
        }

        const nextSecrets = clientSecrets.map((cs, i) => (i === idx ? { ...cs, hasCertificate: true } : cs));
        this.setState({ clientSecrets: nextSecrets });

        const formData = convertDataToFormDataFormat(values);
        if (typeof this.props.upload === "function") {
            this.props.upload(files, formData);
        }
    };

    createTable = (clientSecrets = []) =>
        clientSecrets.map((cs, i) => {
            const end = cs.endDate ? moment(cs.endDate).format("DD-MM-YYYY") : "-";
            return (
                <tr key={cs.hcoNumber || i}>
                    <td style={{ marginRight: "50em" }}>{cs.hcoNumber}</td>
                    <td style={{ textAlign: "center" }}>{cs.hasCertificate ? <i className="if if-checkmark" /> : null}</td>
                    <td style={{ marginRight: "70em" }}>{end}</td>
                </tr>
            );
        });

    handleChange = (event, items = []) => {
        const selectedIndex = event.target.options.selectedIndex;
        const chosen = selectedIndex > 0 ? items[selectedIndex - 1] : null;
        this.setState({
            hcoNumber: event.target.value,
            selectedIndex,
            clientid: chosen ? chosen.clientId : "",
            secretid: chosen ? chosen.secretId : ""
        });
        this.props.selectedRiziv(selectedIndex);
    };

    handleClick = () => {
        this.setState({ files: [] });
    };

    render() {
        var labelStyle = {
            color: "#323335",
            fontWeight: "500",
            padding: "0.8rem 0"
        };

        const { t, handleSubmit, disableUploadButton } = this.props;
        const { clientid, secretid, isAuthenticated, clientSecrets, loading } = this.state;
        const currentLang = this.props.i18n.language;

        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                    <Spinner size="large" />
                </div>
            );
        } else if (!isAuthenticated) {
            return <p>{t("error.unauthorized")}</p>;
        } else {
            return (
                <FlexContainer vertical center>
                    <ToastContainer toastClassName="cc-toast-item" bodyClassName="cc-toast-body" />

                    <div style={{ margin: 20 }}>
                        <Brand logo="./images/mark.svg" brandName="CareConnect" productName="EWZCFin" size="large" />
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        <Button text="EN" styleType={currentLang === "en" ? "primary" : "borderless"} onClick={() => this.changeLanguage("en")} />
                        <Button text="FR" styleType={currentLang === "fr" ? "primary" : "borderless"} onClick={() => this.changeLanguage("fr")} />
                        <Button text="NL" styleType={currentLang === "nl" ? "primary" : "borderless"} onClick={() => this.changeLanguage("nl")} />
                    </div>
                    <FlexContainer horizontal>
                        <CardBody>
                            <Form onSubmit={handleSubmit(this.onSubmit)} style={{ width: "320px" }}>
                                <div className="c-input">
                                    <label className="c-input__label" style={labelStyle}>
                                        {t("forms.number.inami.label")} *
                                    </label>

                                    <div style={{ padding: "8px" }}>
                                        <Field
                                            label={t("forms.number.inami.label")}
                                            //value={this.state.hcoNumber}
                                            onChange={event => this.handleChange(event, clientSecrets)}
                                            name="Riziv"
                                            required
                                            component="select"
                                            hintText={t("forms.number.inami.placeholder")}
                                        >
                                            <option style={{ padding: "8px" }} value="" disabled>
                                                {t("forms.number.inami.placeholder")}
                                            </option>

                                            {clientSecrets.map((item, i) => (
                                                <option key={item.hcoNumber} value={item.hcoNumber}>
                                                    {item.hcoNumber}
                                                </option>
                                            ))}
                                        </Field>
                                    </div>
                                </div>

                                <Field
                                    label={t("forms.password.keystore.label")}
                                    name="KeyStore"
                                    placeholder={t("forms.password.keystore.placeholder")}
                                    validate={[requiredVal, max50]}
                                    component={ReduxFieldText}
                                    required
                                    type="password"
                                    //value={this.state.keyStore}
                                />

                                <Field
                                    label={t("forms.password.keystore.repeat.label")}
                                    name="KeyStoreVerification"
                                    placeholder={t("forms.password.keystore.repeat.placeholder")}
                                    validate={[requiredVal, max50]}
                                    component={ReduxFieldText}
                                    required
                                    type="password"
                                    //value={this.state.keyStoreVerification}
                                />

                                <Field
                                    label={t("forms.application.id.label")}
                                    name="ApplicationId"
                                    placeholder={t("forms.application.id.placeholder")}
                                    //validate={[requiredVal, max50]}
                                    validate={[max50]}
                                    component={ReduxFieldText}
                                    //value={this.state.applicationId}
                                />

                                <br />
                                <section>
                                    <div className="dropzone">
                                        <Dropzone
                                            onDrop={this.onDrop}
                                            accept=".pfx,.p12,.acc-p12,application/x-pkcs12,application/octet-stream"
                                            style={{
                                                width: "100%",
                                                height: "120px",
                                                borderWidth: 2,
                                                borderColor: "#666",
                                                borderStyle: "dashed",
                                                borderRadius: 5,
                                                textAlign: "center",
                                                paddingTop: "30px"
                                            }}
                                        >
                                            <p>{t("forms.dropzone.message")}</p>
                                        </Dropzone>
                                    </div>

                                    <aside>
                                        <h2 style={{ marginTop: "15px" }}>{t("forms.label.certificate")}</h2>

                                        {this.state.files.map(f => {
                                            return (
                                                <label style={{ textOverflow: "ellipsis", overflow: "hidden" }} key={f.name}>
                                                    {f.name}
                                                    <Button onClick={this.handleClick} styleType="borderless" iconType="delete" />
                                                </label>
                                            );
                                        })}
                                    </aside>
                                </section>
                                <br />
                                <Button
                                    disabled={disableUploadButton}
                                    styleType="primary"
                                    type="submit"
                                    text={disableUploadButton ? t("forms.button.saving") : t("forms.button.save")}
                                    iconType={disableUploadButton ? "spinner" : undefined}
                                />

                                <p>&nbsp;</p>
                            </Form>
                        </CardBody>
                        <FlexItem>
                            <CardBody>
                                <FlexContainer>
                                    <FlexItem>
                                        <InputContainer label={t("forms.application.clientId.label")}>
                                            <FlexContainer>
                                                <TextInput disabled type="text" value={clientid} />
                                                <FlexItem>
                                                    <CopyToClipboard text={clientid}>
                                                        <Button styleType="borderless" iconType="duplicate" />
                                                    </CopyToClipboard>
                                                </FlexItem>
                                            </FlexContainer>
                                        </InputContainer>
                                    </FlexItem>
                                </FlexContainer>
                                <FlexContainer>
                                    <FlexItem>
                                        <InputContainer label={t("forms.application.secretId.label")}>
                                            <FlexContainer>
                                                <TextInput disabled type="text" value={secretid} />
                                                <FlexItem>
                                                    <CopyToClipboard text={secretid}>
                                                        <Button styleType="borderless" iconType="duplicate" />
                                                    </CopyToClipboard>
                                                </FlexItem>
                                            </FlexContainer>
                                        </InputContainer>
                                    </FlexItem>
                                </FlexContainer>
                            </CardBody>

                            <CardBody>
                                <Table alignMiddle>
                                    <thead>
                                        <tr>
                                            <th>
                                                <p>{t("forms.application.riziv.label")}</p>
                                            </th>
                                            <th>
                                                <p>{t("forms.application.certificate.label")}</p>
                                            </th>
                                            <th>
                                                <p>{t("forms.application.endDate.label")}</p>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>{this.createTable(clientSecrets)}</tbody>
                                </Table>
                            </CardBody>
                        </FlexItem>
                    </FlexContainer>
                </FlexContainer>
            );
        }
    }
}
Upload.propTypes = {
    t: PropTypes.func.isRequired,
    i18n: PropTypes.object.isRequired,
    dropFileCompleted: PropTypes.func.isRequired,
    clientSecretsInitialize: PropTypes.func.isRequired,
    selectedRiziv: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    upload: PropTypes.func,
    disableUploadButton: PropTypes.bool
};

const form = reduxForm({ form: CERTIFICATE_SUBMIT_FORM });

export default compose(translate(), form)(Upload);
